import type { ViewSurfaceItem } from '@cowbell/surface-broker';

type CoverageLockInput = {
  readonly isAvailable?: boolean;
  readonly isSelected?: boolean;
  readonly isEditable?: boolean;
};

/**
 * The one answer to "can the user toggle this coverage's Included checkbox?".
 * The grid's checkboxes and the agent snapshot both read it.
 */
export function coverageLock(
  coverage: CoverageLockInput
): NonNullable<ViewSurfaceItem['locked']> | undefined {
  if (!coverage.isAvailable) {
    return 'not-available';
  }
  if (coverage.isSelected && !coverage.isEditable) {
    return 'mandatory';
  }
  return undefined;
}

export const isMandatoryCoverage = (coverage: CoverageLockInput): boolean =>
  coverageLock(coverage) === 'mandatory';
